export const FETCH_IUNDERSTAND_REQUEST = "FETCH_EMPLOYEES_REQUEST";
export const FETCH_IUNDERSTAND_SUCCESS = "FETCH_EMPLOYEES_SUCCESS";
export const FETCH_IUNDERSTAND_FAILURE = "FETCH_EMPLOYEES_FAILURE";